import React from 'react';
import styled from 'styled-components';
import { type Node } from '@src/pages/journey-map/types';

interface TooltipProps {
  x: number;
  y: number;
  visible?: boolean;
  children?: React.ReactNode;
}

const Tooltip = styled.div<TooltipProps>`
  position: absolute;
  left: ${(props) => props.x}px;
  top: ${(props) => props.y}px;
  background: rgb(255 255 255 / 95%);
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
  font-size: 12px;
  color: #333;
  white-space: nowrap;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transition: opacity 0.2s ease;
  pointer-events: none;
  z-index: 99;
  min-width: 250px;
  max-width: 600px;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 14px;
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px solid #eee;
  color: #333;
`;

const EventList = styled.div`
  margin-top: 4px;
  max-height: 400px;
  overflow-y: auto;
  font-family: monospace;
  font-size: 12px;
  padding: 8px;
  border-radius: 4px;
  scrollbar-width: thin;
  scrollbar-color: #999 #f8f9fa;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f8f9fa;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #999;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #666;
  }
`;

const EventItem = styled.div.attrs<{ html?: string }>(({ html }) => ({
  dangerouslySetInnerHTML: html ? { __html: html } : undefined,
}))<{ html?: string }>`
  font-size: 11px;
  color: #666;
  margin: 2px 0;
  padding: 4px 0;
  border-bottom: 1px dashed #ddd;

  &:last-child {
    border-bottom: none;
  }
`;

const formatJSON = (obj: any) => {
  const replacer = (key: string, value: any) => {
    if (value === undefined) return 'undefined';
    if (value === null) return 'null';
    return value;
  };
  try {
    const formatted = JSON.stringify(obj, replacer, 2)
      .replace(/\n/g, '<br/>')
      .replace(/ /g, '&nbsp;')
      .replace(/[{]/g, '<span style="color: #666">{</span>')
      .replace(/[}]/g, '<span style="color: #666">}</span>')
      .replace(/[[\]]/g, (match) => `<span style="color: #666">${match}</span>`)
      .replace(/"([^"]+)":/g, '<span style="color: #2a5fb0">"$1"</span>:')
      .replace(/: "([^"]+)"/g, ': <span style="color: #1a8b1a">"$1"</span>')
      .replace(/: ([0-9.]+)/g, ': <span style="color: #1a8b1a">$1</span>');
    return formatted;
  } catch (e) {
    return String(obj);
  }
};

interface NodeTooltipProps {
  node: Node;
  isVisible: boolean;
  x: number;
  y: number;
}

const NodeTooltip = ({ node, isVisible, x, y }: NodeTooltipProps) => {
  if (!node.events || node.events.length === 0) {
    return null;
  }

  return (
    <Tooltip x={x} y={y} visible={isVisible}>
      <Title>{node.name}</Title>
      <div style={{ color: '#666', marginBottom: '15px', fontSize: '12px' }}>Mapping Rule:</div>
      <div>Double click to view details</div>
      {/*<EventList>*/}
      {/*  {node.events.map((event, index) => (*/}
      {/*    <EventItem key={index} html={formatJSON(event)} />*/}
      {/*  ))}*/}
      {/*</EventList>*/}
    </Tooltip>
  );
};

export default NodeTooltip;
